import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
// import arrow from '../../images/icons8-down.svg';

class RenderEventHeader extends Component {
  render() {
    return(
      <div 
        className={'header-cell pt2 pb2 ' + (this.props.eventId === this.props.activeSort ? ' active' : '')} 
        style={this.props.tableArgs.style} 
        role="row"
        justify="center"
        onClick={this.props.getEventPage.bind(this, this.props.eventId, 0)}>
        <Grid 
          spacing={16}
          container
          alignItems="flex-end">
          <Grid 
            sm={12}
            xs={12} 
            item
            className={'tc fw5 ' + (this.props.eventId === this.props.activeSort ? 't-green' : 't-blue')}>
            {/*<p className="ma0 subtext">*/}
              Event {this.props.tableArgs.label}  {(this.props.eventId === this.props.activeSort ?
                <i alt="arrow-direction" className={'ml-2 fas ' + (this.props.reverse ? ' fa-sort-amount-down' : 'fa-sort-amount-up')} ></i> 
              : '')}
            {/*</p>*/}
          </Grid>
        </Grid>
      </div>
    )
  }
}

RenderEventHeader.propTypes = {
  tableArgs: PropTypes.object.isRequired,
  // activeSort: PropTypes.number,
  updateSort: PropTypes.func.isRequired,
  getEventPage: PropTypes.func.isRequired,
  eventObject: PropTypes.array.isRequired,
  eventId: PropTypes.number.isRequired,
  reverse: PropTypes.bool.isRequired
}

export default RenderEventHeader;